import React, { useState } from 'react'
import Module from '../../layout/Module'
import ButtonStartIcon from '../../button/ButtonStartIcon'
import DialogUpdatePassword from './UpdatePassword'
import useFetchData from '../../../hooks/useFetchData'
import UserFormSkeleton from '../../skeleton/UserFormSkeleton'
import { useSelector } from 'react-redux'

const Profile = () => {
  const [show, setShow] = useState(false)
  const { isLoading, data } = useFetchData('auth/profile')
  const domains = useSelector((
    state) => state?.tenant?.sso?.filter((sso) => sso.isEnabled)
    .map((sso) => sso.domain)
    || []
  )

  return (
    <Module>
      <Module.Header
        title='Profile'
      >
        { (domains.includes(data?.email?.split('@')[1]) &&
          !data?.roles?.some((role) => role.name === 'Parent'))
          ? <></>
          : <ButtonStartIcon
            onClick={() => setShow(true)}
            startIcon='key'
            color='secondary'
            bGcolor='secondary'
          >
            Update password
          </ButtonStartIcon>
        }
        </Module.Header>
      <Module.Body>
        <Module.BodyFullContainer className='overflow-auto'>
          <UserFormSkeleton isLoading={isLoading} form={data || {}} />
        </Module.BodyFullContainer>
      </Module.Body>
      { show && 
        <DialogUpdatePassword show={show} onClose={() => setShow(false)} />
      }
    </Module>
  )
}

export default Profile